"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitingTimeImage = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var styles_1 = require("../../../shared/core/utils/styles");
var RawWaitingTimeImage = function (props) {
    var colors = (0, styled_components_1.useTheme)().colors;
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 163 163", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("rect", { width: "163", height: "163", rx: "81.5001", fill: "currentColor", fillOpacity: "0.1" }),
        react_1.default.createElement("circle", { cx: "131.911", cy: "135.833", r: "24.305", fill: colors.focus }),
        react_1.default.createElement("g", { clipPath: "url(#clip0_1144_16823)" },
            react_1.default.createElement("path", { d: "M144.199 133.902H135.338L138.919 130.217C135.351 126.688 129.575 126.558 126.007 130.086C122.439 133.628 122.439 139.339 126.007 142.881C129.575 146.423 135.351 146.423 138.919 142.881C140.696 141.13 141.585 139.078 141.585 136.49H144.199C144.199 139.078 143.049 142.437 140.749 144.711C136.161 149.258 128.712 149.258 124.125 144.711C119.551 140.176 119.512 132.805 124.099 128.27C128.686 123.735 136.044 123.735 140.631 128.27L144.199 124.597V133.902ZM133.09 131.132V136.686L137.664 139.405L136.723 140.986L131.13 137.666V131.132H133.09Z", fill: colors.primaryContrast })),
        react_1.default.createElement("path", { opacity: "0.3", d: "M96.3279 42.895H77.5283V50.4148H96.3279V42.895Z", fill: "currentColor" }),
        react_1.default.createElement("path", { opacity: "0.3", d: "M90.6883 50.4146H83.1685V56.0544H90.6883V50.4146Z", fill: "currentColor" }),
        react_1.default.createElement("path", { opacity: "0.3", d: "M56.6607 101.173H43.689V108.693H62.8646C60.4207 106.437 58.3527 103.993 56.6607 101.173Z", fill: "currentColor" }),
        react_1.default.createElement("path", { opacity: "0.3", d: "M32.4097 86.1343V93.6541H53.0892C52.3372 91.2102 51.7734 88.7662 51.3974 86.1343H32.4097Z", fill: "currentColor" }),
        react_1.default.createElement("path", { opacity: "0.3", d: "M39.9292 71.0945V78.6143H51.3971C51.5851 75.9824 52.3369 73.5384 53.0889 71.0945H39.9292Z", fill: "currentColor" }),
        react_1.default.createElement("path", { d: "M86.9283 54.1748C71.3247 54.1748 58.729 66.7705 58.729 82.3741C58.729 97.9777 71.3247 110.573 86.9283 110.573C102.532 110.573 115.128 97.9777 115.128 82.3741C115.128 66.7705 102.532 54.1748 86.9283 54.1748ZM90.6882 82.3741H83.1684V63.5746H90.6882V82.3741Z", fill: "currentColor" }),
        react_1.default.createElement("path", { opacity: "0.3", d: "M111.387 54.094L95.1064 63.4938L98.8664 70.0059L115.147 60.6062L111.387 54.094Z", fill: "currentColor" }),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_1144_16823" },
                react_1.default.createElement("rect", { width: "31.3655", height: "31.3655", fill: colors.primaryMuted, transform: "translate(116.754 120.677)" })))));
};
exports.WaitingTimeImage = (0, styled_components_1.default)(RawWaitingTimeImage)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), (0, styles_1.svgWidth)('163px', 163, 163));
var templateObject_1;
